import { Reveal } from "@/components/common/Reveal";
import { SectionHeading } from "@/components/common/SectionHeading";
import { ECOSYSTEM } from "@/lib/content";

export function Ecosystem() {
  return (
    <section className="relative py-28 sm:py-36" data-testid="ecosystem">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionHeading
          center
          eyebrow="Notre écosystème"
          lines={["Des sociétés qui partagent", "leurs forces."]}
          sub="Les sociétés du groupe mutualisent leurs ressources et créent des synergies durables."
          className="mb-20"
        />

        <div className="relative grid gap-6 lg:grid-cols-3 items-stretch">
          {[
            { country: "France 🇫🇷", company: "Losta Tech SAS" },
            { country: "Holding", company: "Losta Group", center: true },
            { country: "Suisse 🇨🇭", company: "Luxury Signs Sàrl" },
          ].map((n, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                className={`rounded-2xl border p-8 text-center h-full flex flex-col items-center justify-center ${
                  n.center ? "border-[var(--gold)]/40 bg-[var(--gold)]/[0.04]" : "border-white/10 card-lux"
                }`}
              >
                <div className="eyebrow mb-3">{n.country}</div>
                <div className={`font-serif text-2xl sm:text-3xl ${n.center ? "text-gold" : "text-white"}`}>{n.company}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            {ECOSYSTEM.map((e) => (
              <span
                key={e}
                className="rounded-full border border-white/10 bg-white/[0.02] px-5 py-2.5 text-sm text-slate-300 hover:border-[var(--gold)]/40 hover:text-gold transition-all duration-300"
                data-testid={`ecosystem-chip-${e}`}
              >
                {e}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-16 text-center font-serif font-light text-2xl sm:text-4xl text-white max-w-4xl mx-auto leading-snug">
            Nous ne regardons pas nos métiers de l'extérieur.
            <span className="block text-gold">Nous les pratiquons.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
